const BornToTradePodcastContentFour = () => {
  return (
    <div className="how__work__resource">
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Why Listen to Born to Trade</h4>
              </div>
              <p>
                Hear from leading analysts, economists, and professional traders
                who bring credibility and real-world experience to every
                episode.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Market Insights in Real Time</h4>
              </div>
              <p>
                Get fresh, data-backed discussions on currency trends,
                commodities, crypto, and global equities.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Actionable Strategies</h4>
              </div>
              <p>
                Walk away with proven tactics, risk management techniques, and
                tools you can apply directly to your trades.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Accessible Anytime, Anywhere</h4>
              </div>
              <p>
                Stream episodes from your favorite platform, on your commute,
                during your workout, or while monitoring the markets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BornToTradePodcastContentFour;
